export class ArraySerializer {
  static serialize(value: string): number[] {
    if (!value || value.trim().length == 0) {
      return []
    }
    return value.toString().split(",").map(i => parseInt(i.trim()))
  }

  static deserialize(arr: number[]): string {
    return arr ? arr.join(", ") : ""
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/attributes/array.serializer.ts